<template>

    <button 
        class="btn flex items-center  font-roboto font-medium px-6 py-2.5 text-xs leading-tight uppercase border-solid border-2 "
        :class="{ 
            'text-purple-100 border-purple-100': !selected,
            'bg-purple-100 text-white border-purple-100': selected
        }">
            {{ text }}
    </button>

</template>

<script>

export default {

    props: {
        text: {
            type: String,
            required: true,
        },

        selected: {
            type: Boolean,
            default: false,
        }
    }

}

</script>
